"use strict";

exports.__esModule = true;
exports.sortEventsByWorkdayStart = void 0;
var _partition3 = _interopRequireDefault(require("ramda/src/partition"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var sortEventsByWorkdayStart = exports.sortEventsByWorkdayStart = function sortEventsByWorkdayStart(events, timezoneName, workdayStartMillis, key) {
  events = events.sort(function (event1, event2) {
    return Number(event1[key || "key"]) - Number(event2[key || "key"]);
  });
  var workdayStartHour = _momentTimezone["default"].utc(workdayStartMillis).tz(timezoneName).startOf("hour").format("HH");
  var _partition = (0, _partition3["default"])(function (event) {
      return Number(event[key || "key"]) >= Number(workdayStartHour);
    }, events),
    current = _partition[0],
    next = _partition[1];
  return [].concat(current, next);
};